export default {"src":"/_next/static/media/tracker-removal-hero.cac979ec.svg","height":154,"width":300,"blurWidth":0,"blurHeight":0};